import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { CsvService } from '../../../services/csv-service/csv.service';

/** Linha do CSV que não pôde ser associada a um pedido. */
export interface LinhaInvalida {
  linha: number;
  valor: string;
  motivo: string;
}

export interface ResumoImportacao {
  total: number;
  validos: number;
  invalidos: LinhaInvalida[];
  arquivo: string;
}

@Component({
  selector: 'app-import-preview',
  standalone: false,
  templateUrl: './import-preview.html',
  styleUrl: './import-preview.scss',
})
export class ImportPreview {
  readonly dialogRef = inject(MatDialogRef<ImportPreview>);

  displayedColumns: string[] = ['linha', 'valor', 'motivo'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public resumo: ResumoImportacao,
    @Inject(CsvService) private csvService: CsvService,
  ) {}

  get temInvalidos(): boolean {
    return this.resumo.invalidos.length > 0;
  }

  baixarInvalidos() {
    const headers = ['linha', 'numero_pedido', 'motivo'];
    const rows = this.resumo.invalidos.map((invalido) => ({
      linha: String(invalido.linha),
      numero_pedido: invalido.valor,
      motivo: invalido.motivo,
    }));

    this.csvService.download(
      `pedidos-nao-encontrados-${moment().format('YYYY-MM-DD-HHmm')}.csv`,
      this.csvService.build(headers, rows),
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
